import { useMemo, type Dispatch, type FC, type SetStateAction } from "react";
import type { TimeInterval } from "../../../../types/time.js";
import { type ComboboxData, Select } from "@mantine/core";
import { useIntl } from "react-intl";
import { IconChevronDown, IconChevronUp, IconClock } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";

export interface TimeIntervalSelectorProps {
  timeInterval: TimeInterval;
  setTimeInterval: Dispatch<SetStateAction<TimeInterval>>;
}

export const TimeIntervalSelector: FC<TimeIntervalSelectorProps> = ({
  timeInterval,
  setTimeInterval,
}) => {
  const intl = useIntl();
  const data = useMemo<ComboboxData>(() => [
    { label: intl.formatMessage({ defaultMessage: "Hourly", id: "options.hourly" }), value: "hour" },
    { label: intl.formatMessage({ defaultMessage: "Daily", id: "options.daily" }), value: "day" },
    { label: intl.formatMessage({ defaultMessage: "Monthly", id: "options.monthly" }), value: "month" },
    { label: intl.formatMessage({ defaultMessage: "Yearly", id: "options.yearly" }), value: "year" },
  ], [intl]);
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <Select
      data={data}
      value={timeInterval}
      onChange={(value) => {
        if (value) setTimeInterval(value as TimeInterval);
      }}
      aria-label={intl.formatMessage({
        defaultMessage: "time interval",
        id: "label.timeInterval",
      })}
      leftSection={<IconClock />}
      onDropdownOpen={open}
      onDropdownClose={close}
      rightSection={opened ? <IconChevronUp /> : <IconChevronDown />}
      withCheckIcon={false}
    />
  );
};
